export default __webpack_public_path__ + "/dist/images/cibecco-logo-new.svg";